// src/api_scripts/getoverridesList.js
import { fetchAllPages } from "../paginationUtils";

const getoverridesList = async (overridesListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/overrides`;

  try {
    // Use the pagination utility to fetch all pages
    const overridesListsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Overrides");
    console.log("Get Overrides List API Response Data (all pages):", overridesListsArray.length, "items");
    return overridesListsArray;

  } catch (error) {
    console.error(`Error fetching Overrides:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getoverridesList;
